module.exports = __webpack_public_path__ + "static/media/checkpoint.ffb8434a.png";